(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avinly-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function addBusinessDays(date, days) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }

    function init(root) {
      if (!root || root.dataset.avpReady) return;
      root.dataset.avpReady = '1';

      var main = root.querySelector('[data-avp-main]');
      var slides = root.querySelectorAll('[data-avp-slide]');
      var thumbs = root.querySelectorAll('[data-avp-thumb]');
      function show(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        if (main && slides[i] && main.scrollWidth > main.clientWidth) {
          main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.avpThumb, 10)); });
      });
      if (main) {
        main.addEventListener('scroll', function () {
          if (main.scrollWidth <= main.clientWidth) return;
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        }, { passive: true });
      }

      var priceEl = root.querySelector('[data-avp-price]');
      root.querySelectorAll('.avp__offers input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked && priceEl) priceEl.textContent = r.dataset.price;
        });
      });

      if (root.dataset.abTest === 'true') {
        var v = null;
        try {
          var q = new URLSearchParams(window.location.search).get('btn');
          if (q === 'a' || q === 'b') { v = q; localStorage.setItem('avinly_btn', v); }
          else { v = localStorage.getItem('avinly_btn'); }
        } catch (e) {}
        if (v !== 'a' && v !== 'b') {
          v = Math.random() < 0.5 ? 'a' : 'b';
          try { localStorage.setItem('avinly_btn', v); } catch (e) {}
        }
        root.classList.add('avp--btn-' + v);
        var abInput = root.querySelector('[data-avp-ab-input]');
        if (abInput) abInput.value = v.toUpperCase();
      }

      var dateEl = root.querySelector('[data-avp-shipdate]');
      if (dateEl) {
        try {
          var d = addBusinessDays(new Date(), parseInt(dateEl.dataset.days, 10) || 0);
          dateEl.textContent = d.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'short', month: 'long', day: 'numeric' });
        } catch (e) {}
      }
    }

    function initAll() { document.querySelectorAll('[data-avp]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-avp]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avinly-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.avtReady) return;
      root.dataset.avtReady = '1';
      var track = root.querySelector('[data-avt-track]');
      if (!track) return;
      function step() { var c = track.querySelector('.avt__card'); return c ? c.offsetWidth + 16 : 300; }
      var prev = root.querySelector('[data-avt-prev]');
      var next = root.querySelector('[data-avt-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      root.querySelectorAll('.avt__card').forEach(function (card) {
        var q = card.querySelector('[data-avt-quote]');
        var btn = card.querySelector('[data-avt-more]');
        if (q && btn && q.scrollHeight > q.clientHeight + 2) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var open = card.classList.toggle('is-open');
            btn.textContent = open ? 'Show less' : 'Read more';
          });
        }
      });
    }
    function initAll() { document.querySelectorAll('[data-avt]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-avt]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
